import React from "react";
import BookItem from "../book/BookItem";
import { useGetBooksQuery } from "../../features/api/apiSlice";
import BookLoader from "../loaders/BookLoader";
import Error from "../ui/Error";
import { useSelector } from "react-redux";

const BookListsSection = () => {
  const {
    data: books,
    error,
    isLoading,
    isError,
    isSuccess,
  } = useGetBooksQuery();
  const { status, search } = useSelector((state) => state.filters);

  // filter by status ...
  const filterByStatus = (book) => {
    if (status === "All") {
      return book;
    } else if (status === "Featured") {
      return book.featured;
    }
  };

  // filter by searchText ...
  const filterBysearch = (book) => {
    let searchText = search.toLowerCase();
    let bookName = book?.name.toLowerCase();
    return bookName.includes(searchText);
  };

  // decide what to render...
  let content;
  if (isLoading)
    content = (
      <>
        <BookLoader />
        <BookLoader />
        <BookLoader />
      </>
    );

  if (!isLoading && isError) content = <Error message={error?.error} />;

  if (!isLoading && !isError && books.length === 0)
    content = <Error message="No book found..." />;

  if (!isLoading && !isError && books.length > 0) {
    let contentToShow;
    contentToShow = books
      .filter(filterByStatus)
      .filter(filterBysearch)
      .map((book) => <BookItem key={book.id} book={book} />);
    content =
      contentToShow.length > 0 ? (
        contentToShow
      ) : (
        <Error message="No book found..." />
      );
  }
  return (
    <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
      {content}
    </div>
  );
};

export default BookListsSection;
